<script lang="ts">
    import HeaderView from "./component/header/HeaderView.svelte";
    import {AuthStore} from "./store/AuthStore";
    import FooterView from "./component/footer/FooterView.svelte";
    import {onMount} from "svelte";
    import FullScreenLoadingView from "./component/common/Loading/FullScreenLoadingView.svelte";
    import CornerMessageView from "./component/common/Message/CornerMessageView.svelte";
    import ConfirmMessageView from "./component/common/Message/ConfirmMessageView.svelte";
    import {SetupHttpRequestUtil} from "./SetupHttpRequestUtil";
    import {FontUtil} from "./lib/Common/Font/FontUtil";
    import AppEnvironmentView from "./component/common/Environment/AppEnvironmentView.svelte";
    import MouseEnterTipsView from "./component/common/Information/MouseEnterTipsView.svelte";
    import Home from "./page/Home/Home.svelte";
    import {AuthViewUtil} from "./page/Auth/AuthViewUtil";
    import Router from "svelte-spa-router";
    import NotFound from "./page/NotFound.svelte";
    import Space from "./page/Space/Space.svelte";
    import App from "./page/Space/App/App.svelte";
    import {UserAgentUtil} from "./lib/Common/UserAgent/UserAgentUtil";
    import {EnvStore} from "./store/EnvStore";
    import QrCodeDialogView from "./component/common/Dialog/QrCodeDialogView.svelte";
    import RightsNotation from "./page/RightsNotation.svelte";
    import SvelteBugFix from "./SvelteBugFix.svelte";
    import SpaceSetting from "./page/Space/Setting/SpaceSetting.svelte";
    import SpacePermission from "./page/Space/Setting/Authority/SpacePermission.svelte";
    import Binary from "./page/Space/App/Binary/Binary.svelte";
    import Admin from "./page/Admin/Admin.svelte";
    import AdminSpaceUserAccessLog from "./page/Admin/SpaceUserAccessLog/AdminSpaceUserAccessLog.svelte";
    import AdminUserList from "./page/Admin/AdminUserList.svelte";
    import osType = EnvStore.osType;


    $: authStoreAuthStatus = AuthStore.authStatus;
    $: osType = EnvStore.osType;

    $: osTypeClass = (() => {
        switch ($osType) {
            case UserAgentUtil.OsType.Windows:
                return 'windows pc';
            case UserAgentUtil.OsType.MacOS:
                return 'mac pc';
            case UserAgentUtil.OsType.Android:
                return 'android sp';
            case UserAgentUtil.OsType.iOS:
                return 'ios sp';
            default:
                return '';
        }
    })();

    $: isShow = (() => {
        if ($osType === UserAgentUtil.OsType.None) {
            return false;
        }
        return true;
    })();

    let previousRoute = null;

    // ルーティング
    function createRoutes() {
        const routes = {};
        // 認証必要なページルーティング
        const authRouteMap = {
            "/": Home,
            "/space/:space_unique_id": Space,
            "/space/:space_unique_id/setting": SpaceSetting,
            "/space/:space_unique_id/permission": SpacePermission,

            "/space/:space_unique_id/app/:app_unique_id": App,
            "/space/:space_unique_id/app/:app_unique_id/binary/:binary_unique_id": Binary,
            // "/space/:space_unique_id/app/:app_unique_id/binary/:binary_unique_id/store_setting": BinaryStoreSetting,


            // "/space/setting": SpaceSetting,


        };
        const authRoutes = AuthViewUtil.createAuthWrapRoutes(authRouteMap, false);
        for (let path in authRoutes) {
            const component = authRoutes[path];
            routes[path] = component;
        }

        // 認証とAdmin権限が必要なルーティング
        const adminAuthRouteMap = {
            "/admin": Admin,
            "/admin/space_user_access_log": AdminSpaceUserAccessLog,
            "/admin/user_list": AdminUserList,
        }
        const adminAuthRoutes = AuthViewUtil.createAuthWrapRoutes(adminAuthRouteMap, true);
        for (let path in adminAuthRoutes) {
            const component = adminAuthRoutes[path];
            routes[path] = component;
        }

        // 認証不要なページルーティング
        routes["/rights_notation"] = RightsNotation;
        routes["*"] = NotFound;

        return routes;
    }

    onMount(() => {
        console.log('App.onMount');

        // OSTypeを設定
        const osType = UserAgentUtil.getOsType();
        EnvStore.osType.set(osType);

        // HttpRequest の初期設定
        SetupHttpRequestUtil.setup();

        // Font設定
        FontUtil.WebFont.load(FontUtil.WebFont.Url.NotoSansJP);

    });

    /**
     * ページ移動時の処理
     * @param event
     */
    function onRouteLoaded(event) {
        // console.log('routeLoaded', event);

        if (event.detail.route !== previousRoute) {
            // ページ遷移時に一番上へ自動スクロール
            window.scrollTo(0, 0);

            previousRoute = event.detail.route;
        }
    }

</script>
<svelte:head>

    <style lang="scss" src="./css/ValueTable.scss"/>
    <style lang="scss" src="./css/ColorTable.scss"/>
    <style lang="scss" src="./css/common/StandardTag.scss"/>
    <style lang="scss" src="./css/common/StandardClass.scss"/>
    <style lang="scss" src="./css/common/StandardAnimation.scss"/>
    <style lang="scss" src="./css/common/StandardSP.scss"/>

</svelte:head>

<SvelteBugFix/>

{#if isShow}
    <main class={osTypeClass}>
        <div class="header">
            <HeaderView/>
        </div>

        <div class="body">
            <Router routes={createRoutes()} on:routeLoaded={onRouteLoaded}/>
        </div>

        <div class="footer">
            <FooterView/>

        </div>


        <div id="portal-target"></div>

        <div class="search-dialog-area">
        </div>

        <QrCodeDialogView/>

        <MouseEnterTipsView/>

        <ConfirmMessageView/>
        <CornerMessageView/>
        <FullScreenLoadingView/>

        <div id="hamburger-menu-portal-target"></div>

        <AppEnvironmentView/>
    </main>

{/if}

<style lang="scss">

    main {
        margin: 0 auto;
        background: var(--background);

        font-size: var(--font-size-default);

        min-height: 100vh;
        display: flex;
        flex-direction: column;
        color: var(--text-color);

        .header {

        }

        .body {
            flex-grow: 1;

        }

        .footer {

        }


        font-family: Noto Sans JP, sans-serif;


    }


</style>


